module.exports = __webpack_public_path__ + "6766719f6c07be891aaa3096fa28c870.png";